const COUPON_CALLOUTS_BACKEND_URL = "https://api.price-platform-service-cdn.pai.vpsvc.com/v1/pricing";
const DEBOUNCE_TIME = 100;
const EXPIRES_3DAYS = 3 * 24 * 60 * 60 * 1e3;

export { COUPON_CALLOUTS_BACKEND_URL, DEBOUNCE_TIME, EXPIRES_3DAYS };
//# sourceMappingURL=src-constants-api.constants.js.map
